var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"is_watch_image operation_icon",attrs:{"src":_vm.getSelectedImage()},on:{"click":function($event){return _vm.toggle()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }